// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"dO-z","carouselContainer":"eO-z"};